/*
 * Lib Module Strings
 */

Lib.String = (function () {
    var self = {};

    /**
     *
     * @param str
     * @returns {string}
     */
    self.ucFirst = function (str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };

    /**
     *
     * @param str
     * @param len
     * @param char
     * @returns {string}
     */
    self.padRight = function (str, len, char) {
        return str + new Array(len - str.length + 1).join(char || " ");
    };

    /**
     *
     * @param text
     * @returns {string|void|*}
     */
    self.br2nl = function (text) {
        return (text + '').replace(/<br\s*[\/]?>/gi, "\n");
    };

    /**
     *
     * @param text
     * @returns {string|void|*}
     */
    self.nl2br = function (text) {
        return (text + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2');
    };

    self.camelize = function (str) {
        return str.split('_').map(function (word, index) {
            // If it is the first word make sure to lowercase all the chars.
            if (index === 0) {
                return word.toLowerCase();
            }
            // If it is not the first word only upper case the first char and lowercase the rest.
            return self.ucFirst(word);
        }).join('');
    };


    /**
     *
     * @param encodedString
     * @returns {*}
     */
    self.decodeEntities = function (encodedString) {
        return Lib.Element.spawn('textarea', {}, encodedString).val();
    };

    /**
     *
     * @param htmlString
     * @returns {*}
     */
    self.encodeEntities = function (htmlString) {
        return Lib.Element.spawn('div').text(htmlString).html();
    };


    /**
     *
     * @param str
     * @param truncateLength
     * @param ellips
     * @returns {string}
     */
    self.truncate = function (str, truncateLength, ellips) {
        ellips = ellips || '...';
        return str.substring(0, Math.min(truncateLength, str.length)) + (str.length > truncateLength ? ellips : '');
    };

    return self;

})();

